import { InjectionKey } from 'vue';

import { BillingInteraction, BillingQuery } from '@/types/billing';

export const ProvidedOpenComparisonPlanModal: InjectionKey<
  (opts: BillingInteraction, query: BillingQuery) => void
> = Symbol();

export const ProvidedOpenTalkToSalesModal: InjectionKey<() => void> = Symbol();
